import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getViewInvoice = async (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  const response = await axios.get(
    `${base_url}invoince/viewInvoice?${queryParams}`,
    config
  );
  return response.data;
};

const getInvoiceData = async (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  const response = await axios.get(
    `${base_url}invoince/getInvoiceData?${queryParams}`,
    config
  );
  return response.data;
};
const deleteInvoice = async (invoiceData) => {
  const response = await axios.delete(
    `${base_url}invoince/deleteInvoince`,
    { data: invoiceData, ...config } // Pass invoice_no in the request body
  );
  return response.data;
};
const getMonthlyAllInvoice = async (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  const response = await axios.get(
    `${base_url}invoince/viewMonthlyAllInvoice?${queryParams}`,
    config
  );
  return response.data;
};

const createInvoices = async (invoicedata) => {
  const response = await axios.post(
    `${base_url}invoince/createInvoice`,
    invoicedata,
    config
  );
  return response.data; // Ensure backend returns { data: { invoice: {...} } }
};

const uploadCsvs = async (formData) => {
  const response = await axios.post(
    `${base_url}invoince/uploadInvoiceViaFile`,
    formData,
    config
  );
  return response.data; // Ensure backend returns { data: { invoices: [...] } }
};

const getCollectionInfo = async (filters = {}) => {
  const queryParams = new URLSearchParams(filters).toString();
  const response = await axios.get(
    `${base_url}invoince/collectionInfo?${queryParams}`,
    config
  );
  return response.data;
};

const getCollectionInfoForVc = async (filters = {}) => {
  const response = await axios.get(
    `${base_url}invoince/collectionInfoForVC`,
    config
  );
  return response.data;
};

const invoiceService = {
  getViewInvoice,
  getInvoiceData,
  getMonthlyAllInvoice,
  createInvoices,
  uploadCsvs,
  getCollectionInfo,
  getCollectionInfoForVc,
  deleteInvoice,
};

export default invoiceService;
